import { Modal } from "react-bootstrap";
import { FaRegCircle } from "react-icons/fa6";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";

const OpenOrgDeleteModal = ({
    show,
    handleClose,
    errorMessage,
    handleDeleteOrg,
    loadinDeleteOrg
}) => {
    const {t} = useLanguage()

    return (
        <Modal show={show} onHide={handleClose} size="sm" centered className="mcp_modal_custom">
            <div className="logout_modal_body">
                <p className="logout_modal_body_title">{t.organizations.confirm_title}</p>
                <p className="logout_modal_body_desc">{t.organizations.confirm_subtitle}</p>
            </div>

            <div className="modal_footer_logout">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <button className="modale_close_btn" onClick={handleClose}>
                    {t.close}
                </button>
                <button
                    className="modale_save_btn_delete"
                    onClick={handleDeleteOrg}
                    disabled={loadinDeleteOrg}
                >
                    {loadinDeleteOrg ? <Spinner loading={true} /> : t.organizations.i_confirm}
                </button>
            </div>
        </Modal>
    );
};

export default OpenOrgDeleteModal
    ;